import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type StateService from 'garaje/services/state';
import { DEFAULT_TIMEZONE } from 'garaje/utils/date-fns-tz-utilities';
import { reads } from 'macro-decorators';

export default class ManageEventLogController extends Controller {
  @service declare state: StateService;

  queryParams = ['page', 'search', 'sort', 'productAreas', 'actors', 'eventTypes'];

  @tracked page = 1;
  @tracked search = '';
  @tracked sort = 'event_timestamp:desc';
  @tracked productAreas: string[] = [];
  @tracked actors: string[] = [];
  @tracked eventTypes: string[] = [];

  @reads('state.currentLocation.timezone', DEFAULT_TIMEZONE) declare readonly timezone: string;

  @action
  changeSearch(search: string): void {
    this.search = search;
    this.page = 1; // Reset to first page
  }

  @action
  changeSort(sort: string): void {
    this.sort = sort;
    this.page = 1; // Reset to first page
  }

  @action
  changeProductAreas(productAreas: string[]): void {
    this.productAreas = productAreas;
    this.page = 1; // Reset to first page
  }

  @action
  changeActors(actors: string[]): void {
    this.actors = actors;
    this.page = 1; // Reset to first page
  }

  @action
  changeEventTypes(eventTypes: string[]): void {
    this.eventTypes = eventTypes;
    this.page = 1; // Reset to first page
  }

  @action
  changeLocation(_locationId: number | null): void {
    // No-op for local event log
  }
}
